import { GuardianRelationship } from "../types/guardianTypes";
import { TFunction } from "i18next";

export const GUARDIAN_RELATIONSHIP_OPTIONS = (
  t?: TFunction
): { label: string; value: GuardianRelationship }[] => [
  { label: t ? t("father") : "Father", value: "father" },
  { label: t ? t("mother") : "Mother", value: "mother" },
  { label: t ? t("guardian") : "Guardian", value: "guardian" },
];
